import { gql } from '@apollo/client';

export const STATS = gql`
  query getStats($which: String!, $word: String) {
    statsFor(stat: $which, word: $word) {
      description
      count
      date
      count_firsts
      days_since_last_message
      percentage
    }
  }
`;

export const MESSAGE = gql`
  query getMessage($id: Int!) {
    messageById(id: $id) {
      id
      parent_id
      first
      subject
      name
      body
      date
      has_attachment
      attachments {
        url
        filename
        type
      }
      replies {
        id
        parent_id
        first
        subject
        name
        body
        date
        has_attachment
        attachments {
          url
          filename
          type
        }
      }
    }
  }
`;

export const MESSAGES_BY_NAME_WORD = gql`
  query getMessage($name: String!, $word: String!, $offset: Int, $limit: Int) {
    messagesByNameWord(
      name: $name
      word: $word
      offset: $offset
      limit: $limit
    ) {
      id
      parent_id
      first
      subject
      name
      body
      date
      has_attachment
    }
  }
`;

export const MESSAGES_BY_DATE = gql`
  query getMessage($date: String!, $name: String, $offset: Int, $limit: Int) {
    messagesByDate(date: $date, name: $name, offset: $offset, limit: $limit) {
      id
      parent_id
      first
      subject
      name
      body
      date
      has_attachment
    }
  }
`;

export const MESSAGES_BY_SUBJECT = gql`
  query getMessage($subject: String!, $offset: Int, $limit: Int) {
    messagesBySubject(subject: $subject, offset: $offset, limit: $limit) {
      id
      parent_id
      first
      subject
      name
      body
      date
      has_attachment
    }
  }
`;

export const HEAT = gql`
  query getHeat($who: String, $allTime: Boolean) {
    numbersForHeat(who: $who, allTime: $allTime) {
      year
      heat {
        date
        count
        level
      }
    }
  }
`;

export const MAP = gql`
  query getMap {
    locationsForMap {
      description
      coordinates {
        latitude
        longitude
      }
      icon
      location_updated_at
    }
  }
`;

export const LOGIN = gql`
  mutation login($username: String!, $password: String!) {
    login(username: $username, password: $password)
  }
`;

export const CHART = gql`
  query dataForChart($segments: Int!, $since: String) {
    dataForChart(segments: $segments, since: $since) {
      date
      data {
        name
        count
      }
    }
  }
`;

export const CHART_TIME_OF_DAY = gql`
  query dataForTimeOfDayChart($from: String!, $to: String!, $who: String) {
    dataForTimeOfDayChart(from: $from, to: $to, who: $who) {
      name
      count
      hour
    }
  }
`;

export const MESSAGE_TREE = gql`
  query getMessageTree($id: Int!) {
    messageTree(id: $id) {
      id
      parent_id
      first
      subject
      name
      body
      date
      has_attachment
    }
  }
`;

export const MESSAGE_ADDED_SUBSCRIPTION = gql`
  subscription OnMessageAdded {
    messageAdded {
      id
      parent_id
      first
      subject
      name
      body
      date
      msg_date
      has_attachment
      attachments {
        url
        filename
        type
      }
    }
  }
`;

export const ATTACHMENT_ADDED_SUBSCRIPTION = gql`
  subscription OnAttachmentAdded {
    attachmentAdded {
      filename
      url
      type
      id
      size
    }
  }
`;

export const GET_USERS = gql`
  query getUsers {
    users {
      name
      unix_username
      birthday
      latitude
      longitude
      active
      color
      admin
      updated_at
      updated_by
      location_updated_at
    }
  }
`;

export const SNAP_USERS = gql`
  query snapUsers {
    snapUsers {
      username
      photoCount
      firstDate
      lastDate
    }
  }
`;

export const SNAP_PHOTOS = gql`
  query snapPhotos(
    $username: String!
    $offset: Int
    $limit: Int
    $fromMonth: String
  ) {
    snapPhotos(
      username: $username
      offset: $offset
      limit: $limit
      fromMonth: $fromMonth
    ) {
      total
      photos {
        date
        caption
        commentCount
      }
    }
  }
`;

export const SNAP_MONTHS = gql`
  query snapMonths($username: String!) {
    snapMonths(username: $username) {
      month
      count
    }
  }
`;

export const SNAP_PHOTO_DETAIL = gql`
  query snapPhotoDetail($username: String!, $date: String!) {
    snapPhotoDetail(username: $username, date: $date) {
      date
      caption
      prevDate
      nextDate
      comments {
        username
        body
        changed
      }
    }
  }
`;

export const UPDATE_USER = gql`
  mutation updateUser($name: String!, $input: UserInput!) {
    updateUser(name: $name, input: $input) {
      name
      unix_username
      birthday
      latitude
      longitude
      active
      color
      admin
      updated_at
      updated_by
      location_updated_at
    }
  }
`;
